



































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import RecordViewContent from '@/components/record/recordViewContent.vue';
import { Student } from '@/modules/student';
import { GradesTypes } from '@/enums/gradesTypes';
import { SchoolTypes } from '@/enums/schoolTypes';

@Component({
  components: {
    'record-view-content': RecordViewContent
  }
})
export default class RecordView extends Vue {
  private GradesTypes = GradesTypes;
  private SchoolTypes = SchoolTypes;

  @Prop() private studentId: string;
  @Prop() private tab: string;
  @Prop() private schoolType: string;
  @Prop() private otherTest: string;

  private activeTab = 'report';
  private isLoadedReport = false;
  private isLoadedRoutineTest = false;
  private isLoadedOtherTest = false;
  private isReportChanged = false;
  private isRoutineTestChanged = false;
  private isOtherTestChanged = false;
  private condition = {
    schoolType: SchoolTypes.ElementarySchool,
    otherTest: '',
  };
  private student: Student | null = null;

  get schoolId(): string {
    return this.$store.getters['auth/schoolId'];
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  get pageTitle(): string {
    if (!this.student) {
      return '';
    } else {
    return `
      <span style="display:inline-block;">${this.student.lastName}　${this.student.firstName} さん</span>
      <span style="display:inline-block;">の成績</span>`;
    }
  }

  @Watch('schoolId')
  private changeSchoolId() {
    this.removeEventListener();
  }

  @Watch('condition.schoolType')
  private onChangeItemSchoolType() {
    switch (this.activeTab) {
      case 'routineTest':
        this.isLoadedReport = false;
        this.isLoadedOtherTest = false;
        break;
      case 'otherTest':
        this.isLoadedReport = false;
        this.isLoadedRoutineTest = false;
        break;
      default: // report
        this.isLoadedRoutineTest = false;
        this.isLoadedOtherTest = false;
        break;
    }
  }

  private created() {
    this.loadCondition();
  }

  private mounted() {
    this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private destroyed() {
    this.removeEventListener();
  }

  private loadCondition() {
    let activeTab: string;
    if (!this.tab) {
      activeTab = localStorage.getItem('recordView/activeTab') as string;
    } else {
      switch (this.tab) {
        case String(GradesTypes.RoutineTest):
          activeTab = 'routineTest';
          break;
        case String(GradesTypes.OtherTest):
          activeTab = 'otherTest';
          break;
        default:
          activeTab = 'report';
          break;
      }
    }
    localStorage.removeItem('recordView/activeTab');
    if (!activeTab) {
      this.activeTab = 'report';
    } else {
      switch (activeTab) {
        case 'routineTest':
        case 'otherTest':
          this.activeTab = activeTab;
          break;
        default:
          this.activeTab = 'report';
          break;
      }
    }
  }

  private async loadData() {
    this.student = await this.$store.dispatch('student/getStudent', this.studentId).catch((error) => {
      return null;
    });

    if (!this.student) {
      this.$router.push({
        name: 'RecordList',
      });
      return;
    }

    if (!!this.schoolType) {
      this.condition.schoolType = Number(this.schoolType);

      switch (this.activeTab) {
        case 'otherTest':
          this.condition.otherTest = this.otherTest;
          break;
      }
    } else {
      // 生徒の現在の学校区分をセット
      this.condition.schoolType = this.student.schoolType;
    }

    this.onClickTab();

    this.$nextTick(() => {
      this.addEventListener();
    });
  }

  private onClickTab() {
    this.$nextTick(() => {
      this.viewChart();
    });
  }

  private viewChart() {
    let content: RecordViewContent;
    switch (this.activeTab) {
      case 'routineTest':
        if (this.isLoadedRoutineTest) { return; }
        this.isLoadedRoutineTest = true;
        content = this.$refs.routineTest as RecordViewContent;
        break;
      case 'otherTest':
        if (this.isLoadedOtherTest) { return; }
        this.isLoadedOtherTest = true;
        content = this.$refs.otherTest as RecordViewContent;
        break;
      default: // report
        if (this.isLoadedReport) { return; }
        this.isLoadedReport = true;
        content = this.$refs.report as RecordViewContent;
        break;
    }
    content.viewData();
  }

  private addEventListener() {
    window.addEventListener('beforeunload', this.leaving);

    const page = this.$el.getElementsByClassName('page-content-main')[0];
    page.addEventListener('scroll', this.onScroll);

    const content = this.$el.getElementsByClassName('el-tabs__content')[0];
    content.addEventListener('resize', this.onResize);

    this.onScroll();
  }

  private removeEventListener() {
    window.removeEventListener('beforeunload', this.leaving);

    const page = this.$el.getElementsByClassName('page-content-main')[0];
    page.removeEventListener('scroll', this.onScroll);

    const content = this.$el.getElementsByClassName('el-tabs__content')[0];
    content.removeEventListener('resize', this.onResize);
  }

  private onScroll() {
    const header = this.$el.getElementsByClassName('el-tabs__header')[0];
    const content = this.$el.getElementsByClassName('el-tabs__content')[0];
    const y = content.getBoundingClientRect().top;
    if (115 > y) {
      if (!header.classList.contains('fixed')) {
        header.classList.add('fixed');
        content.classList.add('content-margin');
        this.onResize();
      }
    } else {
      if (header.classList.contains('fixed')) {
        header.classList.remove('fixed');
        content.classList.remove('content-margin');
        this.onResize();
      }
    }
  }

  private onResize() {
    const header = this.$el.getElementsByClassName('el-tabs__header')[0] as HTMLElement;

    if (header.classList.contains('fixed')) {
      const content = this.$el.getElementsByClassName('el-tabs__content')[0] as HTMLElement;
      header.style.width = `${content.offsetWidth}px`;
    } else {
      header.style.width = '';
    }
  }

  private leaving(e: any) {
    localStorage.setItem('recordView/activeTab', this.activeTab);

    if (this.isReportChanged || this.isRoutineTestChanged || this.isOtherTestChanged) {
      e.returnValue = '';
    }
  }
}
